// App id codes for usage in tracking login attempts
export enum AppIdCodes {
    Sphinnx = "SPX",
    RMS = "RMS"
}
